import { Component } from '@angular/core';

@Component({
  selector: 'app-default-eula',
  standalone: true,
  imports: [],
  templateUrl: './default-eula.component.html',
  styleUrl: './default-eula.component.scss',
})
export class DefaultEulaComponent {}
